import type { Schemas } from "~/types/generated";

export enum ChartViewEnum {
  YES = "yes",
  NO = "no",
  BOTH = "both",
  CONSENSUS = "consensus",
}

export enum NewsSentimentEnum {
  POSITIVE = "Positive",
  NEGATIVE = "Negative",
  NEUTRAL = "Neutral",
}

export enum ChartSettingEnum {
  AUTOSCALE = "autoscale",
  X_AXIS = "xAxis",
  Y_AXIS = "yAxis",
  HORIZONTAL_GRID = "horizontalGrid",
  VERTICAL_GRID = "verticalGrid",
  VOLUME = "volume",
  NEWS = "news",
}

export enum EventChartRangeEnum {
  H1 = "1H",
  H6 = "6H",
  D1 = "1D",
  W1 = "1W",
  M1 = "1M",
  ALL = "ALL",
}

export type ChartSide = ChartViewEnum.YES | ChartViewEnum.NO;

export type ChartSettingsState = Record<ChartSettingEnum, boolean>;

interface IChartRequestParams {
  markets: string;
  range?: EventChartRangeEnum;
  since?: string;
}

export interface IChartSelection {
  selections: string[];
  range: EventChartRangeEnum;
}

export type IGetChartChanceHistoryRequestParams = IChartRequestParams;
export type IGetChartVolumeRequestParams = IChartRequestParams;
export type IGetChartNewsMarkersRequestParams = IChartRequestParams;

export type IMarketGroupChanceHistory = Schemas["MarketGroupChanceHistoryDto"];
export type IVolumePoint = Schemas["VolumePointDto"];
export type INewsMarker = Schemas["NewsMarkerDto"];

export type INewsSentiment = NonNullable<INewsMarker["sentiment"]>;

export type IGetChartChanceHistoryResponseBody = IMarketGroupChanceHistory[];
export type IGetChartVolumeResponseBody = IVolumePoint[];
export type IGetChartNewsMarkersResponseBody = INewsMarker[];
